import { useMachine } from '@zag-js/svelte';
import { machine, connect } from '@zag-js/popover';
import { useConnect } from '../../utils/useConnect.svelte.js';
export const usePopover = (props) => {
    const stateMachine = useMachine(machine, {
        ...props,
        defaultOpen: props.open,
        open: props.open
    });
    return useConnect(stateMachine, connect);
};
